import { render, staticRenderFns } from "./ProductSingle.vue?vue&type=template&id=d18f7382&scoped=true&lang=pug"
import script from "./ProductSingle.vue?vue&type=script&lang=js"
export * from "./ProductSingle.vue?vue&type=script&lang=js"
import style0 from "./ProductSingle.vue?vue&type=style&index=0&id=d18f7382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18f7382",
  null
  
)

export default component.exports